export default "__VITE_ASSET__CgUmOUw8__"